
import React from "react";
import { Link } from "react-router-dom";
import { Container , Row , Col } from "reactstrap";
import './Herosection.css';

import heroImg from '../../assets/images/hero.jpg';

function  Herosection () {
    return(
        <section  className="hero__section">
            <Container> 
                <Row  >
                    <Col  lg="6"  md="6">
                        <div  className="hero__content">
                            <h2> 
                                Discover rare digital art and collect <span> sell extraaodinary  </span>  NFTs              
                            </h2>

                            <p>
                            NFT is a unique digital identifier that is recorded on a blockchain and is used to certify ownership and authenticity. It cannot be copied, substituted, or subdivided  The ownership of an NFT is recorded in the blockchain and can be transferred by the owner
                            </p>

                            <div className="hero__btns  d-flex  align-items-center gap-4  ">
                                <button  className="explore__btn   d-flex  align-items-center gap-2"> 
                                    <i class="ri-rocket-line"></i> 
                                    <Link  to='/market'> Explore </Link> 
                                </button>

                                <button  className="create__btn   d-flex  align-items-center gap-2"> 
                                    <i class="ri-ball-pen-line"></i> 
                                    <Link  to='/create'> Create </Link> 
                                </button>
                            </div>
                        </div>
                    </Col>


                    <Col lg='6'  md='6'  className="">
                        <div className="hero__img">
                            <img  src={heroImg} className="w-100" />

                        </div>


                    </Col>

                </Row>
            </Container>
        </section>
    );
}

export  default  Herosection;

